import React, { useContext } from "react";
import "./index.scss";
import classNames from "classnames";
import { QuestionContent } from "../QuestionContent";
import { QuestionContext } from "../../context";
import { RichText } from "../RichText";

export function QuestionSubject({
    className,
    children,
    style
}: RenderComponent) {
    const ctx = useContext(QuestionContext);
    if (ctx.type !== "Subjective") throw new Error("error type data");

    return (
        <div className={classNames("QuestionSubject", className)} style={style}>
            <QuestionContent />

            {ctx.data.requirement && (
                <RichText className="QuestionContent">
                    {ctx.data.requirement}
                </RichText>
            )}

            {children}
        </div>
    );
}
